import * as React from "react";

import { Resources, useResource } from "Translations/Resources";

import { Copyright } from "Components/Layout/CopyRight";
import Typography from "@material-ui/core/Typography";
import styled from "styled-components";

type Props = {
  title: string;
  subTitle: string;
  image: JSX.Element;
  btn?: JSX.Element;
  isLoginPage?: boolean;
};

const StyledWrapper = styled.div`
  display: grid;
  grid-template-rows: auto 1fr auto;
  min-height: ${props => props.theme.vh(100)};
  gap: 24px 0;
`;

const StyledTitleWrapper = styled.div`
  padding: ${props => props.theme.spacing(2, 4)};
`;

const StyledSubTitle = styled(Typography)`
  font-weight: 300;
`;

const StyledLogin = styled.div`
  justify-self: center;
  align-self: center;

  & > div {
    background-color: #fff;
    box-shadow: ${props => props.theme.shadow.primary};
    padding: ${props => props.theme.spacing(3, 4)};
    width: 800px;
    max-width: 100vw;
    display: grid;
    grid-template-columns: auto auto;
    align-items: center;

    h1 {
      padding-bottom: 5px;
    }
    p {
      padding-bottom: ${props => props.theme.spacing(3)}px;
    }
  }

  @media (max-width: 730px) {
    justify-self: flex-start;
    align-self: flex-start;
    & > div {
      display: flex;
      flex-flow: column-reverse;
      padding: ${props => props.theme.spacing(3, 2)};
      padding-bottom: ${props => props.theme.spacing(6)}px;

      & > div {
        display: grid;
        justify-items: center;
      }
    }
  }
`;

const StyledImage = styled.div`
  justify-self: center;
  img {
    pointer-events: none;
    width: 435px;
  }

  @media (max-width: 730px) {
    img {
      width: auto;
      height: 220px;
    }
  }
`;

export const UnauthenticatedLayout: React.FunctionComponent<Props> = props => {
  const { t } = useResource();

  return (
    <StyledWrapper id={props.isLoginPage ? "login-block" : ""}>
      <StyledTitleWrapper>
        <Typography variant={"h1"}>{t(Resources.Common.App.Name)}</Typography>
        <StyledSubTitle>{t(Resources.Common.App.SubTitle)}</StyledSubTitle>
      </StyledTitleWrapper>

      <StyledLogin>
        <div>
          <div>
            <Typography variant={"h1"}>{props.title}</Typography>
            <StyledSubTitle>{props.subTitle}</StyledSubTitle>
            {props.btn}
          </div>
          <StyledImage>{props.image}</StyledImage>
        </div>
      </StyledLogin>

      <div>
        <Copyright />
      </div>
    </StyledWrapper>
  );
};
